import React from "react";
import { Link } from "react-router-dom";
import CheckAll from "../../../../../../assets/images/LearningSession/LearningCheckAll.png";
import "./LearningSessionResultNav.css";

const LearningSessionResultNav = ({ checkResult, setCheckResult }) => {
  return (
    <div className="mb-3 row">
      <div
        title="Live Now"
        className="col-md-2 align-items-center justify-content-center "
      >
        <div className="card card-bg nav-body-dashboard mb-3">
          <div className="card-body  align-items-center">
            <center>
              <tr>
                <td className="livechat-card-td">
                  <img src={CheckAll} className="img-top" alt="..." />
                </td>
                {/* <td className="livechat-card-td">
                  <small className="p-3 fw-bold rounded-1 text-warning textFontResult">Approved</small>
                </td> */}
              </tr>
            </center>
          </div>
          {/* <div to="" className="card-footer livechat-card-footer"> */}
          <button
            onClick={() => setCheckResult(1)}
            className={
              checkResult === 1
                ? `livechat-card-footer-active p-2`
                : `livechat-card-footer p-2`
            }
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            {" "}
            Check All Result
          </button>
          {/* </div> */}
        </div>
      </div>
      <br />

      <div
        title="Live Now"
        className="col-md-2 align-items-center justify-content-center "
      >
        <div className="card card-bg nav-body-dashboard mb-3">
          <div className="card-body  align-items-center">
            <center>
              <tr>
                <td className="livechat-card-td">
                  <img src={CheckAll} className="img-top" alt="..." />
                </td>
                <td className="livechat-card-td">
                  <small className="livechat-card-small bg-black p-3 fw-bold rounded-1">
                    03
                  </small>
                </td>
              </tr>
            </center>
          </div>

          <button
            onClick={() => setCheckResult(2)}
            className={
              checkResult === 2
                ? `livechat-card-footer-active p-2`
                : `livechat-card-footer p-2`
            }
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            {" "}
            Request for Certificate
          </button>
          {/* </Link> */}
        </div>
      </div>
      <br />
    </div>
  );
};

export default LearningSessionResultNav;
